module.exports = __webpack_public_path__ + "img/5.3f21f407.png";